export const PRODUCT_SPECS = {
  // CAL VIRGEM CALCÍTICA
  'cal-calcitica-virgem': {
    quimica: {
      'CaO total': 'até 95%',
      'CaO disponível': 'até 90%',
      'MgO': 'até 3%',
      'PPC (1000ºC)': 'até 6%',
      'Reatividade ASTM (ºC)': 'até 3\'/60ºC',
      'Reatividade Wuhrer (mL)': 'até 350 mL',
      'SiO2 + RI': 'até 2,5%',
      'Fe2O3': 'até 1%',
      'Al2O3': 'até 1%',
      'Enxofre (S)': 'até 0,5%',
      'Fósforo (P)': 'até 0,2%',
    },
    granulometria: {
      'Micropulverizada': '200 mesh, 100 mesh e 50 mesh',
      'Britada': '0-50mm, 0-40mm, 0-3mm, 0-6mm, 2-6mm, 3-19mm, 6-19mm, 19-40mm, 19-50mm',
    },
  },

  // CAL VIRGEM DOLOMÍTICA
  'cal-dolomitica-virgem': {
    quimica: {
      'CaO total': 'até 60%',
      'CaO disponível': 'até 50%',
      'MgO': 'até 38%',
      'PPC (1000ºC)': 'até 8%',
      'Reatividade Wuhrer (mL/10min)': 'até 300',
      'SiO2 + RI': 'até 6%',
      'CO2': 'até 15%',
      'Fe2O3': 'até 0,5%',
      'Al2O3': 'até 0,5%',
      'Enxofre (S)': '< 0,5%',
      'Fósforo (P)': '< 0,5%',
    },
    granulometria: {
      'Micropulverizada': '200 mesh, 100 mesh e 50 mesh',
      'Britada': '0-50mm, 0-40mm, 0-3mm, 0-6mm, 3-19mm, 6-19mm, 19-40mm, 19-50mm',
    },
  },

  // CAL HIDRATADA CALCÍTICA
  'cal-calcitica-hidratada': {
    quimica: {
      'CaO total': 'até 80%',
      'MgO': 'até 3%',
      'Ca(OH)2': 'até 92%',
      'PPC (1000ºC)': 'até 30%',
      'SiO2 + RI': 'até 5%',
      'Fe2O3': 'até 1%',
      'Al2O3': 'até 1%',
    },
    granulometria: {
      'Micropulverizada': '200 mesh, 100 mesh e 50 mesh (Industrial, CHI e CHIII)',
    },
  },

  // CAL HIDRATADA DOLOMÍTICA
  'cal-dolomitica-hidratada': {
    quimica: {
      'CaO total': 'até 45%',
      'MgO': 'até 30%',
      'Ca(OH)2': 'até 65%',
      'PPC (1000ºC)': 'até 25%',
      'SiO2 + RI': 'até 10%',
      'CO2': 'até 12%',
      'Umidade': 'até 1%',
    },
    granulometria: {
      'Micropulverizada': '200 mesh, 100 mesh e 50 mesh (Industrial, CHI e CHIII)',
    },
  },
} as const;

export type ProductSpecKey = keyof typeof PRODUCT_SPECS;